// extracted by mini-css-extract-plugin
module.exports = {"Canvas":"CharacterCanvas_Canvas__3y4WG"};